var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6026 9.26766C22.3254 9.46226 22.8953 10.0322 23.0899 10.755C23.4513 12.0755 23.4374 14.8278 23.4374 14.8278C23.4374 14.8278 23.4374 17.5661 23.0899 18.8866C22.8953 19.6095 22.3254 20.1794 21.6026 20.374C20.2821 20.7215 15 20.7215 15 20.7215C15 20.7215 9.73176 20.7215 8.39734 20.3601C7.67452 20.1655 7.10461 19.5956 6.91001 18.8727C6.5625 17.5661 6.5625 14.8139 6.5625 14.8139C6.5625 14.8139 6.5625 12.0755 6.91001 10.755C7.10461 10.0322 7.68842 9.44836 8.39734 9.25376C9.71786 8.90625 15 8.90625 15 8.90625C15 8.90625 20.2821 8.90625 21.6026 9.26766ZM17.7105 14.7173L13.318 17.2472V12.1875L17.7105 14.7173Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube__white.8b9e785a3ffef83e31525251830eecdf.svg";
export { ForwardRef as ReactComponent };